module.exports = __webpack_public_path__ + "img/001-man.934ab19f.svg";